import React, { useState } from 'react';
import { TextEditor } from '../TextEditor';

const EmailForm = ({ recipient, onClose, profile }) => {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      window.location.href = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
      onClose(); // Cierra el formulario después de enviar el correo
    };
  
    return (
      <div className='w-full'>
        <div className="flex flex-col w-full p-3 gap-[10px] rounded-[4px] border-[1px] border-nemu-plata ">
            <div className='flex h-max gap-2'>
                <img className='cursor-pointer h-[20px]' src='assets/Notifications/arrowNot.svg' alt='Enviar correo'/>
                <h2 className="text-base">{profile} ({recipient})</h2>
            </div>
            <hr className='m-0'></hr>
          <form onSubmit={handleSubmit}>
            <TextEditor/>
            <div className='flex justify-end gap-2'>
                <div className='py-[4px] px-3 text-nemu-black border-[1px] border-nemu-black rounded-[4px] transition-all duration-300 hover:bg-nemu-platino hover:scale-105 '>
                    <span>Rechazar</span>
                </div>
                <div className='py-[4px] px-3 text-white bg-nemu-azul rounded-[4px] transition-all duration-300 hover:bg-nemu-azulOscuro hover:scale-105 '>
                    <span>Aceptar</span>
                </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

export {EmailForm}